import React from "react";
import Header from "./Header";
import PqrsdAdminList from "../pqrsd/PqrsdAdminList";

export default function LayoutPqrsdTriage() {
  return (
    <>
      <Header />
      <PqrsdAdminList scope="triage" />
    </>
  );
}
